const messagePane = document.getElementById('rolexMessageArea');
const contactDetailsPane = document.getElementById('rolexClientInfo');
const loadingPane = document.getElementById('rolexMessageLoading');
const thankYouPane = document.getElementById('rolexThankYouForContacingUs');

const messageInput = document.getElementById('rolexMessageInput');
const nameInput = document.getElementById('firstNameInput');
const emailInput = document.getElementById('emailInput');
const replyToInput = document.getElementById('replyToInput');
const firstNameInput = document.getElementById('firstNameInput');
const surnameInput = document.getElementById('surnameInput');
const phoneNumberInput = document.getElementById('phoneNumberInput');
const termsInput = document.getElementById('termsInput');

const firstNameLabel = document.getElementById('firstNameLabel');
const surnameLabel = document.getElementById('surnameLabel');
const emailLabel = document.getElementById('emailLabel');
const conjunction = document.getElementById('emailPhoneConjunction');
const termsLabel = document.getElementById('termsValidationMessage');

const clientConsent = document.getElementById('termsConditionsAndPrivacyPolicy');

const completionHint = document.getElementById('formCompletionHint');

const nextButton = document.getElementById('nextButton');
const backButton = document.getElementById('backButton');
const submitButton = document.getElementById('submitButton');


// Hide the message entry and show the user info fields when the client presses the 'next' button
nextButton.addEventListener('click', function() 
{
    messagePane.style.display = 'none';
    contactDetailsPane.style.display = 'grid';
    location.hash = '';     
    location.hash = 'message';  
});

// Hide the user info fields and return to the message entry pane when the client presses the 'back' button
backButton.addEventListener('click', function() 
{
    messagePane.style.display = 'grid';
    contactDetailsPane.style.display = 'none';
    location.hash = '';     
    location.hash = 'message';
});

// Observe when both the message pane and contact details pane are hidden at the same time
const interstitialObserver = new MutationObserver((mutations) => {
    if (messagePane.style.display === 'none' && contactDetailsPane.style.display === 'none') 
    {  
        console.log('Communicating with Shopify Server');
        location.hash = '';     
        location.hash = 'message';
        loadingPane.style.display = 'grid'; // Display the spinner when nothing else is visible 
    }
});
interstitialObserver.observe(messagePane, { attributes: true, attributeFilter: ['style'] });
interstitialObserver.observe(contactDetailsPane, { attributes: true, attributeFilter: ['style'] });

// Handle the form submission
submitButton.addEventListener('click', function() 
{
    location.hash = '';     
    location.hash = 'message';
    contactDetailsPane.style.display = 'none';
    thankYouPane.style.display = 'grid';
});

// Check that the message entry contains text before enabling the 'next' button
window.onload = function() 
{
    checkForMessageContent();
};

function checkForMessageContent() 
{
    if (messageInput.value == '') 
    {
        nextButton.disabled = true;
    } 
    else 
    {
        nextButton.disabled = false;
    }
}

// Disable the 'send' button until the required fields are satisfied
function checkFormValidity() 
{
    // Check if name fields are filled out
    const firstNameValue = firstNameInput.value.trim();
    const surnameValue = surnameInput.value.trim();
    const isNameValid = firstNameValue.length > 0 && surnameValue.length > 0;

    // Check for a valid email address format
    const emailValue = emailInput.value.trim();
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailValue);

    // Check for a valid phone number (local or international)
    const phoneNumberValue = phoneNumberInput.value.replace(/[()\s-]/g, '');
    const isPhoneNumberValid = /^\d{10,16}$/.test(phoneNumberValue);

    // Check and/or state of email address and phone number
    const contactChecksPassed = ((isEmailValid && isPhoneNumberValid) || (isEmailValid && (phoneNumberValue.length == 0 || phoneNumberValue == undefined || phoneNumberValue == null)) || (isPhoneNumberValid && (emailValue.length == 0 || emailValue == undefined || emailValue == null)));

    var emailOrPhoneText = 'either a valid email address or a valid phone number that we can reach you at';
    if (!contactChecksPassed && isEmailValid)
    {
      // a valid email is present, but the checks didn't pass, so there must be an issue with the phone number
      emailOrPhoneText = 'a valid phone number that we can reach you at';
    }
    else if (!contactChecksPassed && isPhoneNumberValid)
    {
      // a valid phone number is present, but the checks didn't pass, so there must be an issue with the email address
      emailOrPhoneText = 'a valid email address that we can reach you at';
    }

    // Show a completion hint if fields are missing
    if (!clientConsent.checked && !isNameValid && !contactChecksPassed) 
    {
        completionHint.innerHTML = '';

        if (firstNameValue.length > 0 && surnameValue.length < 1) 
        {
            completionHint.innerHTML = 'Please provide a last name and ' + emailOrPhoneText + ' before sending your message. Please also ensure that you have read and accepted our terms and conditions as well as our privacy policy.';
        } 
        else if (firstNameValue.length < 1 && surnameValue.length > 0) 
        {
            completionHint.innerHTML = 'Please provide your first name and ' + emailOrPhoneText + ' before sending your message. Please also ensure that you have read and accepted our terms and conditions as well as our privacy policy.';
        } 
        else 
        {
            completionHint.innerHTML = 'Please provide your name and ' + emailOrPhoneText + ' before sending your message. Please also ensure that you have read and accepted our terms and conditions as well as our privacy policy.';
        }
    } else if (clientConsent.checked && !isNameValid && contactChecksPassed) 
    {
        if (firstNameValue.length > 0 && surnameValue.length < 1) 
        {
            completionHint.innerHTML = 'Please provide a last name before sending your message.';
        } 
        else if (firstNameValue.length < 1 && surnameValue.length > 0) 
        {
            completionHint.innerHTML = 'Please provide your first name before sending your message.';
        } 
        else 
        {
            completionHint.innerHTML = 'Please provide your name before sending your message.';
        }
    } 
    else if (clientConsent.checked && !isNameValid && !contactChecksPassed) 
    {
        if (firstNameValue.length > 0 && surnameValue.length < 1) 
        {
            completionHint.innerHTML = 'Please provide a last name and ' + emailOrPhoneText + ' before sending your message.';
        } 
        else if (firstNameValue.length < 1 && surnameValue.length > 0) 
        {
            completionHint.innerHTML = 'Please provide your first name and ' + emailOrPhoneText + ' before sending your message.';
        } 
        else 
        {
            completionHint.innerHTML = 'Please provide your name and ' + emailOrPhoneText + ' before sending your message.';
        }
    } 
    else if (clientConsent.checked && isNameValid && !contactChecksPassed) 
    {
        completionHint.innerHTML = 'Please provide ' + emailOrPhoneText + ' before sending your message.';
    } 
    else if (!clientConsent.checked && !isNameValid && contactChecksPassed) 
    {
        if (firstNameValue.length > 0 && surnameValue.length < 1) 
        {
            completionHint.innerHTML = 'Please provide a last name before sending your message. Please also ensure that you have read and accepted our terms and conditions as well as our privacy policy.';
        } 
        else if (firstNameValue.length < 1 && surnameValue.length > 0) 
        {
            completionHint.innerHTML = 'Please provide your first name before sending your message. Please also ensure that you have read and accepted our terms and conditions as well as our privacy policy.';
        } 
        else 
        {
            completionHint.innerHTML = 'Please provide your name before sending your message. Please also ensure that you have read and accepted our terms and conditions as well as our privacy policy.';
        }
    } 
    else if (!clientConsent.checked && isNameValid && !contactChecksPassed) 
    {
        completionHint.innerHTML = 'Please provide ' + emailOrPhoneText + ' before sending your message. Please also ensure that you have read and accepted our terms and conditions as well as our privacy policy.';
    } 
    else if (!clientConsent.checked) 
    {
        completionHint.innerHTML = 'Please read and agree to our terms and conditions as well as our privacy policy before sending your message.';
    } 
    else if (clientConsent.checked && isNameValid && contactChecksPassed) 
    {
        completionHint.innerHTML = '';
        hideCompletionHint();
    }

    // Enable or disable the submit button based on form validity
    submitButton.disabled = !clientConsent.checked || !isNameValid || !contactChecksPassed;

    // Indicate any fields requiring the client's attention
    if (completionHint.style.opacity == 1) 
    {
        if (firstNameValue.length > 0) 
        {
            firstNameInput.removeAttribute('aria-errormessage');
            firstNameInput.removeAttribute('aria-invalid');
            firstNameInput.placeholder = 'First Name';
            firstNameLabel.classList.remove('crimson');
            firstNameLabel.classList.remove('bold');
            firstNameLabel.classList.add('chestnut-brown-subdued');
            firstNameLabel.innerHTML = 'First Name<span class="disclaimer-superscript">*</span>';
        } 
        else 
        {
            firstNameInput.setAttribute('aria-errormessage', 'Please enter your first name to submit the form.');
            firstNameInput.setAttribute('aria-invalid', 'true');
            firstNameInput.placeholder = 'First Name*';
            firstNameLabel.classList.add('crimson');
            firstNameLabel.classList.add('bold');
            firstNameLabel.classList.remove('chestnut-brown-subdued');
            firstNameLabel.innerHTML = 'Please enter your name';
        }

        if (surnameValue.length > 0) 
        {
            surnameInput.removeAttribute('aria-errormessage');
            surnameInput.removeAttribute('aria-invalid');
            surnameInput.placeholder = 'Last Name';
            surnameLabel.classList.remove('crimson');
            surnameLabel.classList.remove('bold');
            surnameLabel.classList.add('chestnut-brown-subdued');
            surnameLabel.innerHTML = 'Last Name<span class="disclaimer-superscript">*</span>';
        } 
        else 
        {
            surnameInput.setAttribute('aria-errormessage', 'Please enter your last name to submit the form.');
            surnameInput.setAttribute('aria-invalid', 'true');
            surnameInput.placeholder = 'Last Name*';
            surnameLabel.classList.add('crimson');
            surnameLabel.classList.add('bold');
            surnameLabel.classList.remove('chestnut-brown-subdued');
            surnameLabel.innerHTML = 'Please enter your last name';
        }

        if (contactChecksPassed) // email and/or phone check cleared
        {
            emailLabel.classList.add('chestnut-brown-subdued');
            emailLabel.classList.remove('crimson');
            emailLabel.classList.remove('bold');
            emailLabel.innerHTML = 'Email Address<span class="disclaimer-superscript">*</span>';
            emailInput.removeAttribute('aria-errormessage');
            emailInput.removeAttribute('aria-invalid');
            emailInput.placeholder = 'Your Email Address';
            phoneNumberInput.removeAttribute('aria-errormessage');
            phoneNumberInput.removeAttribute('aria-invalid');
            phoneNumberInput.placeholder = 'Your Phone Number';
            conjunction.classList.remove('crimson');
            conjunction.classList.remove('bold');
            conjunction.classList.add('chestnut-brown-subdued'); 
        } 
        else // provide the client with guidance on what needs addressing in the email/phone number fields
        {
            var messageToDisplay = 'Please include a valid email and/or phone number';
            if (isEmailValid)
            {
                // a valid email is present, but the checks didn't pass, so there must be an issue with the phone number, let the client know
                messageToDisplay = 'Please enter a valid phone number or leave the phone number field blank';
            }
            else if (isPhoneNumberValid)
            {
                // a valid phone number is present, but the checks didn't pass, so there must be an issue with the email address, let the client know
                messageToDisplay = 'Please enter a valid email address or leave the email field blank';
            }
            emailLabel.innerHTML = messageToDisplay;
            emailLabel.classList.remove('chestnut-brown-subdued');
            emailLabel.classList.add('crimson');
            emailLabel.classList.add('bold');

            if (!isEmailValid)
            {
                emailInput.placeholder = 'Email Address*';
                emailInput.setAttribute('aria-errormessage', 'Please enter a valid email address (or a phone number, in the field below) to submit the form.');
                emailInput.setAttribute('aria-invalid', 'true');
            }

            if (!isPhoneNumberValid)
            {
                phoneNumberInput.placeholder = 'Phone Number';
                phoneNumberInput.setAttribute('aria-errormessage', 'Please enter a valid phone number (or an email address, in the field above) to submit the form.');
                phoneNumberInput.setAttribute('aria-invalid', 'true');
            }

            if (!isPhoneNumberValid && !isEmailValid) {
                conjunction.classList.remove('chestnut-brown-subdued');
                conjunction.classList.add('crimson');
                conjunction.classList.add('bold');
            }
        }

        if (clientConsent.checked) 
        {
            termsInput.removeAttribute('style');
            termsInput.removeAttribute('aria-errormessage');
            termsInput.removeAttribute('aria-invalid');
            termsLabel.innerHTML = '';
            termsLabel.classList.add('hidden');
        } 
        else 
        {
            termsInput.style.borderColor = 'var(--crimson)';
            termsInput.setAttribute('aria-errormessage', 'Please accept the terms and conditions to submit the form.');
            termsInput.setAttribute('aria-invalid', 'true');
            termsLabel.innerHTML = '<br><br>Please accept the terms and conditions';
            termsLabel.classList.remove('hidden');
        }
    } 
    else // Ensure all error styling/feedback is removed
    {   
        firstNameInput.removeAttribute('aria-errormessage');
        firstNameInput.removeAttribute('aria-invalid');
        firstNameInput.placeholder = 'First Name';

        firstNameLabel.classList.remove('crimson');
        firstNameLabel.classList.remove('bold');
        firstNameLabel.classList.add('chestnut-brown-subdued');
        firstNameLabel.innerHTML = 'First Name<span class="disclaimer-superscript">*</span>';

        surnameInput.removeAttribute('aria-errormessage');
        surnameInput.removeAttribute('aria-invalid');
        surnameInput.placeholder = 'Last Name';

        surnameLabel.classList.remove('crimson');
        surnameLabel.classList.remove('bold');
        surnameLabel.classList.add('chestnut-brown-subdued');
        surnameLabel.innerHTML = 'Last Name<span class="disclaimer-superscript">*</span>';

        emailLabel.classList.add('chestnut-brown-subdued');
        emailLabel.classList.remove('crimson');
        emailLabel.classList.remove('bold');
        emailLabel.innerHTML = 'Email Address<span class="disclaimer-superscript">*</span>';

        emailInput.removeAttribute('aria-errormessage');
        emailInput.removeAttribute('aria-invalid');
        emailInput.placeholder = 'Your Email Address';

        phoneNumberInput.removeAttribute('aria-errormessage');
        phoneNumberInput.removeAttribute('aria-invalid');
        phoneNumberInput.placeholder = 'Your Phone Number';

        conjunction.classList.remove('crimson');
        conjunction.classList.remove('bold');
        conjunction.classList.add('chestnut-brown-subdued');

        termsInput.removeAttribute('style');
        termsLabel.innerHTML = '';
        termsLabel.classList.add('hidden');
    }

    // Shopify form validation requires an email address, Rolex specifications require that the email address be optional. 
    // To work around this, we set a stand-in, no-reply email as the default, in a hidden input, to satisfy the Shopify validator.
    // If the client supplies a valid email address, swap out the stand-in for the client's email address.
    if (isEmailValid) 
    {
        replyToInput.value = emailInput.value;
    }
}

function showCompletionHint() 
{
    if (completionHint.innerHTML != '') 
    {
        completionHint.style.height = 'fit-content';
        completionHint.style.maxHeight = '360px';
        completionHint.style.padding = '20px';
        completionHint.style.marginBottom = '40px';
        completionHint.style.opacity = 1;
    }
    checkFormValidity();
}

function hideCompletionHint() 
{
    completionHint.style.height = 0;
    completionHint.style.maxHeight = 0;
    completionHint.style.padding = '0 20px';
    completionHint.style.marginBottom = 0;
    completionHint.style.opacity = 0;
}

// Add event listeners to the various input fields
messageInput.addEventListener('input', checkForMessageContent);
firstNameInput.addEventListener('input', checkFormValidity);
surnameInput.addEventListener('input', checkFormValidity);
emailInput.addEventListener('input', checkFormValidity);
phoneNumberInput.addEventListener('input', checkFormValidity);
clientConsent.addEventListener('input', checkFormValidity);

termsInput.addEventListener('keydown', function(event) // Enable keyboard accessibility for custom Rolex checkbox
{
    if (event.key === 'Enter') 
    {
        event.preventDefault(); // Block default behaviour, if any, as a safeguard against input conflicts
        clientConsent.checked = !clientConsent.checked; // Toggle the state of the client consent checkbox
    }
});

// Show hint if client hovers over submit button with required fields incomplete
submitButton.addEventListener('mouseover', showCompletionHint);